import React from 'react';
import cl from './ShippingPolicy.module.css';



const ShippingPolicy = (props) => {
    return (
        <section className={cl.app_policy}>
          <h1>Politique d'expédition</h1>
           <p>Notre objectif est de vous offrir les meilleures options d'expédition, où que vous habitiez. Nous livrons à des centaines de clients à travers le monde
                 chaque jour, et nous nous efforçons de vous fournir des services du plus haut niveau.</p>
           <p>Nous savons qu'une fois que vous avez acheté quelque chose, vous avez hâte de recevoir votre commande dès que possible. Veuillez voir ci-dessous pour plus de détails sur
                 la politique d'expédition.</p>
           <p>Q : Pouvez-vous garantir les délais de livraison ?</p>
             <p>R : Malheureusement, ce n'est pas dû au service postal. Nous expédions les commandes dès que nous le pouvons lorsque nous avons reçu votre
                 paiement. Nous ne traitons pas les commandes pendant le week-end ou les jours fériés.</p>
             <p>Q : Puis-je suivre ma commande ?</p>
             <p>R : Oui ! Notre service est entièrement traçable sur les sites Web.</p>
             <p>Q : Où expédiez-vous ?</p>
             <p>R : Nous expédions dans le monde entier.</p>
             <p>Q : Puis-je demander un remboursement si ma commande n'arrive pas à temps pour une certaine date ?</p>
             <p>R : Non, nous sommes désolés, mais nous ne pouvons pas rembourser les commandes déjà expédiées. Vous pouvez retourner la commande si vous le souhaitez pour un
                 remboursement cependant.</p>
             <p>En raison de l'influence du COVID-19 et des restrictions politiques de divers pays, il y aura un gros retard dans tous les services express.
                 livraisons, et la logistique ne peut pas garantir complètement le délai.</p>
             <p>Délai de livraison ：2-7 jours，délai de livraison：7-15 jours</p>
        </section>
    );
}

export default ShippingPolicy;